import { globalDriveFileState } from "../api";
import type { GlobalDataRecord, GlobalDriveFileState } from "../api";
import folderStyles from "./GlobalDriveFolder.module.css";

const STATE_LABEL: Record<GlobalDriveFileState, string> = {
  ready: "Ready",
  extracting: "Extracting",
  failed: "Extraction failed",
  removed: "Removed",
};

const STATE_CLASS: Record<GlobalDriveFileState, string> = {
  ready: folderStyles.stateReady,
  extracting: folderStyles.stateExtracting,
  failed: folderStyles.stateFailed,
  removed: folderStyles.stateRemoved,
};

// A null record is a tracked file the first sync hasn't fetched yet.
export const GlobalDriveFileStatePill = ({ record }: { record: GlobalDataRecord | null }) => {
  if (record === null) {
    return (
      <span className={`${folderStyles.statePill} ${folderStyles.stateWaiting}`}>
        Waiting for first sync
      </span>
    );
  }
  const state = globalDriveFileState(record);
  return (
    <span className={`${folderStyles.statePill} ${STATE_CLASS[state]}`}>
      {STATE_LABEL[state]}
    </span>
  );
};
